import { ModelComponentEdit } from './component-edit.model';
import { FormSet } from 'src/app/shared/models/form-model/models/form-set.model';
import { FormGroup } from '@angular/forms';

export class SaveForm {
  public MainComponents: ModelComponentEdit[];
  public Form: FormGroup;
  public SetsComponents: FormSet[];
}
